import BackButton from "components/general.compoenents/back.button.component/back.button.component";
import Row from "components/general.compoenents/row.component/row.component";
import Headline from "components/text.components/headline.component/headline.component";
import React from "react";
import "./page.header.component.scss";

interface PageHeaderProps {
  label: string;
  showBackButton?: boolean;
  children?: React.ReactNode | React.ReactNode[];
}

const PageHeader = ({
  label,
  children,
  showBackButton,
}: PageHeaderProps): JSX.Element => {
  return (
    <Row
      className="page-header-container"
      justifyContent="space-between"
      alignItems="center"
    >
      <Row className="action-row" alignItems="center">
        {showBackButton && <BackButton className="mr-20" />}
        <Headline>{label}</Headline>
      </Row>
      <Row className="action-row" alignItems="center" justifyContent="flex-end">
        {children}
      </Row>
    </Row>
  );
};

export default PageHeader;
